"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
/**
 * Clear a notification
 */
function clearNotification() {
  return (0, _actionUtils.actionCreator)(_types.CLEAR_NOTIFICATION, {
    show: false
  });
}
var _default = exports["default"] = clearNotification;